import React, { useCallback, useEffect, useState } from 'react';
import { useUpdateEffect } from 'ahooks';
import classNames from 'classnames';

import { useUserInfo } from 'lib/user';
import { useWeb3Modal } from '@/components/Web3Modal';
import ShowTasks from './ShowTasks';
import Won from './Won';
import Miss from './Miss';
import NotWon from './NotWon';
import WalletCollected from './WalletCollected';
import { useAppSelector } from 'store/hooks';
import Registered from './Registered';
import OwnerOperate from '../OwnerOperate';
import RewardsCount from '../RewardsCount';
import { MyEntry } from 'api/raffle/raffle_detail';

interface IRegisterResultProps {}

const RegisterResult: React.FC<IRegisterResultProps> = ({}) => {
  const { isLogin } = useUserInfo();
  const { toggleWeb3Modal } = useWeb3Modal();

  const {
    raffleInfo: { status, my_entry, type },
  } = useAppSelector((state) => state.raffleDetails);
  const [raffleStatus, setRaffleStatus] = useState('');
  const [raffleType, setRaffleType] = useState('');
  const [myRaffleEntry, setMyRaffleEntry] = useState<MyEntry>();

  useEffect(() => {
    setRaffleStatus(String(status));
    setRaffleType(String(type));
    setMyRaffleEntry(my_entry);
  }, [my_entry, status, type]);

  useUpdateEffect(() => {
    if (isLogin) {
      location.reload();
    }
  }, [isLogin]);

  const wonResultRender = useCallback(() => {
    if (!isLogin) {
      return (
        <div className="text-center">
          <div className="text-2xl font-semibold text-neutral-100">
            Connect your wallet and check your participation.
          </div>
          <div
            className="mt-4 flex h-10 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-base font-normal text-neutral-100 lg:h-12"
            onClick={toggleWeb3Modal}
          >
            Connect
          </div>
        </div>
      );
    } else {
      if (!!myRaffleEntry) {
        if (raffleType === 'WALLET_COLLECTION') {
          return <WalletCollected />;
        } else {
          if (raffleStatus === 'ENDED') {
            return <Registered />;
          } else {
            if (myRaffleEntry.is_win) {
              return <Won />;
            } else {
              return <NotWon />;
            }
          }
        }
      } else {
        return <Miss />;
      }
    }
  }, [isLogin, myRaffleEntry, raffleStatus, toggleWeb3Modal, raffleType]);

  if (raffleStatus !== 'ENDED' && raffleStatus !== 'FINALIZED') {
    return null;
  }

  return (
    <div>
      <OwnerOperate />
      <RewardsCount />
      <div
        className={classNames('rounded-2xl  px-5 py-6', {
          'border border-neutral-600': !(
            !!myRaffleEntry &&
            (raffleType === 'WALLET_COLLECTION' ||
              (raffleType !== 'WALLET_COLLECTION' &&
                myRaffleEntry.is_win &&
                raffleStatus !== 'ENDED')) &&
            isLogin
          ),
          'bg-neutral-900':
            !!myRaffleEntry &&
            (raffleType === 'WALLET_COLLECTION' ||
              (raffleType !== 'WALLET_COLLECTION' &&
                myRaffleEntry.is_win &&
                raffleStatus !== 'ENDED')) &&
            isLogin,
        })}
      >
        {wonResultRender()}
        <ShowTasks />
      </div>
    </div>
  );
};

export default RegisterResult;
